<div class="relative" (clickOutside)="onClickedOutside($event)" #triggerElement>
  <div (click)="toggleOPenOptions()" class="cursor-pointer">
    <!-- Reference this by using the ngProjectAs attribute. eg <div ngProjectAs="clickable-item"> content </div> -->
    <ng-content select="clickable-item"></ng-content>
  </div>

  <!-- The menu is moved to <body> on open; styles live in styles.css (.bk-menu). -->
  @if(openOptions){
  <div
    #dropdownMenu
    role="menu"
    class="bk-menu dropDownSection"
    [ngClass]="className"
    [class.dark]="isDark"
    [class.is-up]="openUp"
    [class.is-right]="anchoredRight"
    [class.is-shown]="positioned"
    [class.invisible]="!positioned"
    [style.top.px]="dropdownTop"
    [style.left.px]="dropdownLeft"
    [style.right.px]="dropdownRight"
  >
    <!-- Reference this by using the ngProjectAs attribute. eg <div ngProjectAs="dropdown-item"> content </div> -->
    <ng-content select="dropdown-item"></ng-content>
  </div>
  }
</div>
